<template>
  <transition name="fade">
    <div v-if="modelValue"
         class="overlay">
      <div class="dialog">
        <button class="close-btn"
                type="button"
                aria-label="关闭公告"
                @click="closeDialog">×</button>

        <div class="content">
          <ul>
            <li v-for="(announcement, index) in announcements"
                :key="index">
              <strong class="content-text">{{ announcement.title }}</strong>
              <vue-markdown-render class="announcement-markdown markdown-body"
                                   :source="announcement.content"
                                   :options="markdownOptions"
                                   @click="handleMarkdownClick" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { defineProps } from 'vue'
import VueMarkdownRender from 'vue-markdown-render'

const markdownOptions = {
  html: true,
  linkify: true,
  breaks: true
}

defineProps<{
  modelValue: boolean // 控制弹窗显示/隐藏
  announcements: { title: string; content: string; date: string }[] // 公告数据
}>()

const emit = defineEmits(['update:modelValue'])

const closeDialog = () => {
  emit('update:modelValue', false) // 关闭弹窗
}

const handleMarkdownClick = (event: MouseEvent) => {
  const target = event.target as HTMLElement | null
  const anchor = target?.closest('a')
  if (anchor) {
    closeDialog()
  }
}
</script>

<style scoped>
/* 遮罩层 */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

/* 弹窗样式 */
.dialog {
  background: transparent;
  border-radius: 8px;
  box-shadow: none;
  width: 640px;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
}

/* 标题栏 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  padding: 20px 28px;
  background: linear-gradient(90deg, #f7f9fb 0%, #2e343a 100%);
  color: #ffffff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  flex: none;
}

.header h3 {
  margin: 0;
  font-weight: 600;
}

/* 关闭按钮 */
.close-btn {
  position: absolute;
  top: 27px;
  right: 36px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.45);
  color: #ffffff;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease;
}

.close-btn:hover {
  background: rgba(0, 0, 0, 0.65);
}

/* 公告内容 */
.content {
  width: calc(100% - 64px);
  max-width: 560px;
  margin: 24px auto;
  padding: 20px 18px 18px;
  max-height: calc(80vh - 120px);
  overflow-y: auto;
  flex: 1;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 28px rgba(27, 39, 62, 0.12);
}
.content-text {
  font-weight: 1000;
  color: red;
  font-size: 18px;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

li {
  padding: 10px;
  border-bottom: 1px solid #eee;
}

li:last-child {
  border-bottom: none;
}


.announcement-markdown {
  margin: 0;
  color: #000000;
}

:deep(.announcement-markdown p) {
  margin: 0;
  line-height: 1.6;
}

:deep(.announcement-markdown a) {
  color: #1677ff;
}

:deep(.announcement-markdown a:hover) {
  text-decoration: underline;
}

.date {
  font-size: 12px;
  color: gray;
}

/* 过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
